import { Component, Input, OnInit, EventEmitter, Output, Inject } from "@angular/core";
import { CommonService } from "../../_services/common.service";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl
} from "@angular/forms";
import { HttpErrorResponse } from "@angular/common/http";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

export interface DialogData {
  projects_data: any;
  storeId: string;
  quoteId: string;
  type: string;
  projectIndex: number;
}

@Component({
  selector: 'app-store-product-price',
  templateUrl: './store-product-price.component.html',
  styleUrls: ['./store-product-price.component.css']
})
export class StoreProductPriceComponent implements OnInit {
  private result = '';
  public activeClass: string = 'active';
  public loading = false;
  public isShowMsg = false;
  public errormsg: string;
  public projectIndex: number = -1;

  constructor(private formBuilder: FormBuilder,
    private CommonService: CommonService,
    public dialogRef: MatDialogRef<StoreProductPriceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit() { 
    if (this.data.projectIndex >= 0) {
      this.projectIndex = this.data.projectIndex;
      console.log("this.projectIndex", this.projectIndex);
    }
  }
  onNoClick() {
    this.dialogRef.close(this.result);
  }
  saveProductPrice = function () {
    //console.log(postData);
    let optionData = {
      'shop_id': localStorage.getItem("userID"),
      'store_id': this.data.storeId,
      'quote_id': this.data.quoteId,
      'projects_data': this.data.projects_data
    }
    for (let p = 0; p < this.data.projects_data.length; p++) {
      for (let prod = 0; prod < this.data.projects_data[p].products.length; prod++) {
        if (this.data.projects_data[p].products[prod].store_commission == 0) {
          this.isShowMsg = true;
          this.errormsg = "Please enter store commission greater than 0";
          setTimeout(function () {
            this.isShowMsg = false;
          }.bind(this), 5000);
          window.scroll(0, 0);
          return;
        }
        if (this.data.projects_data[p].products[prod].retail_price == 0) {
          this.isShowMsg = true;
          this.errormsg = "Please enter retail price greater than 0";
          setTimeout(function () {
            this.isShowMsg = false;
          }.bind(this), 5000);
          window.scroll(0, 0);
          return;
        }
        if (this.data.projects_data[p].products[prod].product_title == '') {
          this.isShowMsg = true;
          this.errormsg = "Please enter product title";
          setTimeout(function () {
            this.isShowMsg = false;
          }.bind(this), 5000);
          window.scroll(0, 0);
          return;
        }
      };
    };
    this.loading = true;
    let apiName = 'store/quoteassign';
    if (this.data.type == 'Update') {
      apiName = 'store/update_product';
    }
    this.CommonService.apiService(
      "POST",
      apiName,
      optionData
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          this.result = "success";
          this.onNoClick();
        }
      },
      err => {
        this.loading = false;
        this.isShowMsg = true;
        this.errormsg = err.error.message;
        setTimeout(function () {
          this.isShowMsg = false;
        }.bind(this), 5000);
        window.scroll(0, 0);
      }

    );

  };

  trackByFn(index: any, item: any) {
    return index;
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-stores/store-product-price/store-product-price.component.ts